// extracted by mini-css-extract-plugin
export default {"text":"Mobile_text__Z0qcf","link":"Mobile_link__xE5cV"};